var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResultPassed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15,
  stroke: "currentColor",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5503 17L14.5859 20.0355L20.9498 13.6716",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgResultPassed;